import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createExercisesApi(client) {
    async function list(query) {
        return unwrap(await client.GET('/v1/exercises', { params: { query: query ?? {} } }));
    }
    return {
        list,
        iterate(query) {
            return paginate(list, query);
        },
        async get(id) {
            return unwrap(await client.GET('/v1/exercises/{id}', { params: { path: { id } } }));
        },
        async create(body) {
            return unwrap(await client.POST('/v1/exercises', { body }));
        },
        async update(id, body) {
            return unwrap(await client.PATCH('/v1/exercises/{id}', { params: { path: { id } }, body }));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/exercises/{id}', { params: { path: { id } } }));
        },
    };
}
//# sourceMappingURL=exercises.js.map